// extracted by mini-css-extract-plugin
export default {"root":"SeccionesText_root__fgoKE","section":"SeccionesText_section__BIAnk"};